import { isStreamIQ, isToya } from '@/shared/lib'

export const getUseVodItemsDetails = async () => {
    if (isToya()) {
        try {
            const module =
                await require('@/clients/toya/features/VOD/hooks/useItemDetailsTOYA')
            // return useItemDetailsTOYA as typeof useItemDetailsTOYA
            return module.default
        } catch (error) {
            console.warn(
                'useItemDetailsTOYA module is missing. Toya-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/shared/hooks/useItemDetailsStreamIQ')
            // return useItemDetailsStreamIQ as typeof useItemDetailsTOYA
            return module.default
        } catch (error) {
            console.warn(
                'useItemDetailsStreamIQ module is missing. Streamiq-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
